<template>
  <section class="p-1">
    <!-- <bread-crumb :bread-crumbs="['Compliance', 'List of Customers']" /> -->

    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">Customers List</div>
        <div>
          <bread-crumb :bread-crumbs="['List of Customers']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form>
            <v-row row-gutters class="px-2">
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  :items="[
                    { text: 'Individual', value: 'IND' },
                    { text: 'Bussiness', value: 'BUS' },
                    { text: 'All', value: 'ALL' },
                  ]"
                  placeholder="Customer Type"
                  v-model="searchInputs.customer_type"
                  outlined
                  dense
                  :clearable="isFieldClearable('customer_type')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  :items="listOfFilters"
                  v-model="userSelectedFilter"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12" v-if="userSelectedFilter">
                <v-text-field
                  v-if="userSelectedFilter === 'Customer ID'"
                  placeholder="Enter Customer ID"
                  v-model="searchInputs.customer_id"
                  outlined
                  dense
                  :clearable="isFieldClearable('customer_id')"
                ></v-text-field>

                <v-text-field
                  v-if="userSelectedFilter === 'Customer Name'"
                  placeholder="Enter Customer Name"
                  v-model="searchInputs.customer_name"
                  outlined
                  dense
                  :clearable="isFieldClearable('customer_name')"
                ></v-text-field>

                <v-text-field
                  v-if="userSelectedFilter === 'ID Number'"
                  placeholder="Enter ID Number"
                  v-model="searchInputs.id_number"
                  outlined
                  dense
                  :clearable="isFieldClearable('id_number')"
                ></v-text-field>

                <v-text-field
                  v-if="userSelectedFilter === 'Email ID'"
                  placeholder="Enter Email"
                  v-model="searchInputs.user_email"
                  outlined
                  dense
                  :clearable="isFieldClearable('user_email')"
                ></v-text-field>
                <v-text-field
                  v-if="userSelectedFilter === 'Phone Number'"
                  placeholder="Enter Phone Number"
                  v-model="searchInputs.phone_number"
                  outlined
                  dense
                  :clearable="isFieldClearable('phone_number')"
                ></v-text-field>
              </v-col>

              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  :items="[
                    { text: 'Active', value: 'Active' },
                    { text: 'In-Active', value: 'In-Active' },
                    { text: 'All', value: 'All' },
                  ]"
                  placeholder="Account status"
                  v-model="searchInputs.account_status"
                  outlined
                  dense
                  :clearable="isFieldClearable('account_status')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  :items="[
                    { text: 'Approved', value: 'Approved' },
                    { text: 'Rejected', value: 'Rejected' },
                    { text: 'Pending', value: 'Pending' },
                    { text: 'All', value: 'ALL' },
                  ]"
                  placeholder="KYC Status"
                  v-model="searchInputs.kyc_status"
                  outlined
                  dense
                  :clearable="isFieldClearable('kyc_status')"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  :items="[
                    { text: 'Creation Date', value: 'creation' },
                    { text: 'Transaction Date', value: 'transaction' },
                  ]"
                  placeholder="Select Filter Date Type"
                  label="Select Filter Date Type"
                  v-model="searchInputs.date_type"
                  outlined
                  dense
                  :clearable="isFieldClearable('kyc_status')"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                lg="3"
                sm="6"
                xs="12"
                v-if="searchInputs.date_type == 'creation'"
              >
                <v-text-field
                  :items="listOfFilters"
                  v-model="searchInputs.from_date"
                  type="date"
                  :rules="[validateFromDate]"
                  label="From Creation Date"
                  outlined
                  dense
                  :clearable="isFieldClearable('from_date')"
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                lg="3"
                sm="6"
                xs="12"
                v-if="searchInputs.date_type == 'creation'"
              >
                <v-text-field
                  :items="listOfFilters"
                  :rules="[validateToDate]"
                  v-model="searchInputs.to_date"
                  type="date"
                  label="To Creation Date"
                  outlined
                  dense
                  :clearable="isFieldClearable('to_date')"
                ></v-text-field>
              </v-col>

              <v-col
                cols="12"
                lg="3"
                sm="6"
                xs="12"
                v-if="searchInputs.date_type == 'transaction'"
              >
                <v-text-field
                  :items="listOfFilters"
                  :rules="[validateFromTxnDate]"
                  v-model="searchInputs.txn_from_date"
                  type="date"
                  label="From Transaction Date"
                  outlined
                  dense
                  :clearable="isFieldClearable('txn_from_date')"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                lg="3"
                sm="6"
                xs="12"
                v-if="searchInputs.date_type == 'transaction'"
              >
                <v-text-field
                  :items="listOfFilters"
                  :rules="[validateToTxnDate]"
                  v-model="searchInputs.txn_to_date"
                  type="date"
                  label="To Transaction Date"
                  outlined
                  dense
                  :clearable="isFieldClearable('txn_to_date')"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" lg="3" sm="6" xs="12">
                <v-autocomplete
                  placeholder="Onboard Channel"
                  outlined
                  dense
                  :clearable="isFieldClearable('')"
                ></v-autocomplete>
              </v-col> -->
              <v-col cols="12" lg="5" xs="12"></v-col>
              <v-col cols="12" lg="5" xs="12"></v-col>
              <div class="d-flex mb-4">
                <div>
                  <v-btn
                    depressed
                    small
                    class="mx-2 ms-3 primary text-capitalize"
                    @click="getRemitteList()"
                    >Get Results</v-btn
                  >
                </div>
                <div>
                  <v-btn
                    depressed
                    small
                    class="mx-2 text-capitalize"
                    outlined
                    color="primary"
                    @click="clear"
                    >Clear</v-btn
                  >
                </div>
              </div>
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>

      <v-card-text>
        <loading
          :active="isloadagents"
          :is-full-page="false"
          :opacity="0.7"
          color="#ff6b00"
        />
        <v-row row-gutters class="">
          <!-- <v-col cols="12" lg="2" xs="12"> <v-btn depressed  class="mx-5 mt-2 text-capitalize" color="primary" 
              @click="$router.push('/compliance/users/addCustomer')"
               outlined>
              <v-icon small>mdi-plus</v-icon> Add Customer
            </v-btn></v-col> -->

          <!-- <v-spacer></v-spacer>outlined
            <v-col cols="12" md="1" xs="12">
            <v-btn depressed  class="mx-2 primary text-capitalize"  @click="getRemitteList">Search</v-btn></v-col>
            <v-col cols="12" md="1" xs="12"><v-btn depressed  class=" ms-0  text-capitalize"   color="primary" @click="clear">Clear</v-btn>
          </v-col> -->
        </v-row>
        <v-row row-gutters class="mt-5 mb-3">
          <v-col cols="12" lg="4" xs="12">
            <v-btn depressed @click="downloadExcelsheet" color="primary" small
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
          </v-col>
          <v-col cols="12" lg="4" xs="12"></v-col>
          <v-col cols="12" lg="4" xs="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>

      <!-- <v-card-text>
        <v-row row-gutters>
          <v-col cols="12" lg="8" xs="12"></v-col>
          <v-col cols="12" lg="4" xs="12">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              single-line
              hide-details
              dense clearable
            ></v-text-field>
          </v-col>        
      </v-row>
      </v-card-text> -->

      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :items="userList"
        :items-per-page="perPageSize"
        :search="search"
        loading-text="Please select the criteria to view records."
        no-data-text="Please select the criteria to view records."
        item-key="user_id"
        dense
      >
        <!-- show-select
        :single-select="singleSelect" -->
        <template v-slot:item.user_type="{ item }">
          <v-chip
            label
            small
            outlined
            :color="item.user_type == 'Individual' ? 'primary' : 'secondary'"
          >
            {{ item.user_type }}
          </v-chip>
        </template>
        <template v-slot:item.risk_status="{ item }">
          <v-chip
            v-if="item.risk_status"
            label
            small
            outlined
            :color="returnColor(item.risk_status)"
          >
            {{ item.risk_status }}
          </v-chip>
          <span v-else>{{ item.risk_status }}</span>
        </template>

        <template v-slot:item.Is_Negativelisted="{ item }">
          <v-icon :color="item.Is_Negativelisted === 2 ? 'red' : 'green'"
            >mdi-flag</v-icon
          >
        </template>

        <template v-slot:item.action="{ item }">
          <v-icon
            color="grey"
            title="View Details"
            class="mr-2"
            @click="nextpage(item)"
          >
            mdi-chevron-right-circle
          </v-icon>
          <!-- <v-btn
            @click="deleteItem(item)"
            small
            class="text-capitalize"
            depressed
            icon
            fab
            color="primary"
          >
            <v-icon small title="Delete " class="">
              mdi-trash-can-outline
            </v-icon>
          </v-btn> -->
        </template>
      </v-data-table>
    </v-card>
    <!-- Delete confirmation popup dialog -->
    <v-dialog persistent v-model="openDialog" width="500">
      <v-card>
        <v-card-title class="border border-bottom">Delete</v-card-title>
        <v-card-text class="h5 py-3"
          >Are you sure you want to delete this customer?</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            small
            color="primary"
            outlined
            @click="deleteCustomerById"
          >
            <v-icon>mdi-check</v-icon>
          </v-btn>
          <v-btn depressed small color="primary" outlined @click="closeDelete()"
            ><v-icon>mdi-close</v-icon></v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
// import listOverviewVue from "../../../components/compliance/users/list-overview.vue";
import Loading from "vue-loading-overlay";
import { mapGetters, mapMutations } from "vuex";
import userService from "@/services/UserService/userService.js";
import alerts from "@/mixins/alerts";
export default {
  name: "List of Customers",
  mixins: [alerts],
  data: () => {
    return {
      delete_customer_id: "",
      openDialog: false,
      itemsPerPage: "10",
      headers: [
        { text: "Customer ID", value: "user_id" },
        { text: "Customer Name", value: "name" },
        { text: "Customer Type", value: "user_type" },
        { text: "ID Number", value: "id_number" },
        { text: "Nationality", value: "nationality" },
        // { text: 'Email ID', value: 'Email_ID', width: 200 },
        { text: "Partner", value: "partner_name" },
        { text: "Phone Number", value: "mobile_number" },
        { text: "Account Status", value: "account_status" },
        { text: "Onboard Status", value: "kyc_status" },
        { text: "Risk Status", value: "risk_status" },
        { text: "Risk Percentage (%)", value: "risk_percentage" },
        {
          text: "Navigation",
          value: "action",
          sortable: false,
          width: 150,
          align: "center",
        },
        // { text: 'Fraudulent', value: 'Is_Negativelisted', width: 80 }
        // { text: '', value: 'data-table-expand' },
      ],
      userList: [],
      tatalcustomerslist: [],
      search: "",
      listOfFilters: [
        "Customer Name",
        "Customer ID",
        "ID Number",
        "Email ID",
        "Phone Number",
      ],
      userSelectedFilter: "Customer Name",
      expanded: [],
      singleExpand: true,
      isloadagents: false,
      skip: 0, // Initial skip value
      limit: 1000, // Initial limit value
      perPageSize: window.innerWidth < 1600 ? 10 : 15,
      searchInputs: {
        customer_type: "ALL",
        date_type: "creation",
        txn_from_date: new Date().toJSON().slice(0, 10),
        txn_to_date: new Date().toJSON().slice(0, 10),
        to_date: new Date().toJSON().slice(0, 10),
        from_date: new Date().toJSON().slice(0, 10),
      },
    };
  },
  components: {
    BreadCrumb,
    // listOverviewVue
    Loading,
  },
  computed: {
    ...mapGetters(["getpreviouspageState"]),
    isPreviousState() {
      return this.getpreviouspageState;
    },
  },
  watch: {
    userSelectedFilter(val) {
      if (val === "Customer ID") {
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      } else if (val === "Customer Name") {
        this.searchInputs.customer_id = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      } else if (val === "ID Number") {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      } else if (val === "Email ID") {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.phone_number = "";
      } else if (val === "Phone Number") {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
      } else {
        this.searchInputs.customer_id = "";
        this.searchInputs.customer_name = "";
        this.searchInputs.id_number = "";
        this.searchInputs.user_email = "";
        this.searchInputs.phone_number = "";
      }
    },
  },
  mounted() {
    if (this.$route.query.totalPendingKYC) {
      this.searchInputs.kyc_status = "Pending";
      this.searchInputs.customer_type = "ALL";
      this.searchInputs.date_type = "";
      this.txn_from_date = null;
      this.txn_to_date = null;
      this.to_date = null;
      this.from_date = null;
      this.getRemitteList();
    }
    if (this.isPreviousState) {
      const previousState = this.isPreviousState;
      this.searchInputs.customer_type =
        previousState.customer_type === "ALL"
          ? null
          : previousState.customer_type;
      this.searchInputs.customer_id = previousState.customer_id;
      this.searchInputs.customer_name = previousState.customer_name;
      this.searchInputs.id_number = previousState.id_number;
      this.searchInputs.user_email = previousState.user_email;
      this.searchInputs.phone_number = previousState.phone_number;
      this.searchInputs.account_status =
        previousState.account_status === "All"
          ? null
          : previousState.account_status;
      this.searchInputs.kyc_status =
        previousState.kyc_status === "ALL" ? null : previousState.kyc_status;
      this.searchInputs.from_date = previousState.from_date;
      this.searchInputs.to_date = previousState.to_date;
      this.searchInputs.txn_from_date = previousState.txn_from_date;
      this.searchInputs.txn_to_date = previousState.txn_to_date;
      this.getRemitteList();
    }
    console.log("queryery", this.$route.query.Totalcus_rejected);
    console.log(this.$store.state);
    if (this.$route.query.All_Customers) {
      this.totalcuslist();
    }
    if (this.$route.query.Todayreg_Customers) {
      this.todayRegcuslist();
    }
    if (this.$route.query.IND_Customers) {
      this.totalINDcuslist();
    }
    if (this.$route.query.BUS_Customers) {
      this.totalBUScuslist();
    }
    if (this.$route.query.Totalcus_rejected) {
      this.totalRejectedcus();
    }
    if (this.$route.query.INDCus_rejected) {
      this.INDRejectedcus();
    }
    if (this.$route.query.BUSCus_rejected) {
      this.BUSRejectedcus();
    }
    if (this.$route.query.All_approval) {
      this.getAllaproval();
    }
    if (this.$route.query.IND_approval) {
      this.getAllaprovalIND();
    }
    if (this.$route.query.BUS_approval) {
      this.getAllaprovalBUS();
    }
    if (this.$route.query.All_hold) {
      this.getAllhold();
    }
    if (this.$route.query.IND_hold) {
      this.getAllholdIND();
    }
    if (this.$route.query.BUS_hold) {
      this.getAllholdBUS();
    }
    if (this.$route.query.Todayreg_Customers) {
      this.getRemitteList();
    }

    this.logComponentPath();
  },

  methods: {
    deleteItem(item) {
      console.log(item);
      this.delete_customer_id = item.customer_id;
      this.openDialog = true;
    },
    closeDelete() {
      this.delete_customer_id = "";
      this.openDialog = false;
    },
    ...mapMutations(["setCustomerRouteData"]),
    returnColor(val) {
      if (val.toLowerCase() == "medium") {
        return "orange";
      } else if (val.toLowerCase() == "high") {
        return "error";
      } else if (val.toLowerCase() == "low") {
        return "success";
      }
      return;
    },
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "List of customers");
      }
    },
    logComponentPath() {
      const currentPath = this.$route.path;
      console.log("Current Component Path:", currentPath);
    },
    validateFromDate(value) {
      if (value && this.searchInputs.to_date) {
        return (
          value <= this.searchInputs.to_date ||
          "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToDate(value) {
      if (value && this.searchInputs.from_date) {
        return (
          value >= this.searchInputs.from_date ||
          "To date cannot be earlier than From date"
        );
      }
      return true;
    },
    validateFromTxnDate(value) {
      if (value && this.searchInputs.txn_to_date) {
        return (
          value <= this.searchInputs.txn_to_date ||
          "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToTxnDate(value) {
      if (value && this.searchInputs.txn_from_date) {
        return (
          value >= this.searchInputs.txn_from_date ||
          "To date cannot be earlier than From date"
        );
      }
      return true;
    },
    isFieldClearable(fieldName) {
      return (
        this.searchInputs[fieldName] !== "" &&
        this.searchInputs[fieldName] !== null
      );
    },
    clear() {
      for (const fieldName in this.searchInputs) {
        this.searchInputs[fieldName] = "";
      }
    },
    async getRemitteList() {
      this.isloadagents = true;
      console.log("rrr", this.searchInputs.customer_type);
      try {
        const params = {
          customer_type: this.searchInputs.customer_type
            ? this.searchInputs.customer_type
            : "ALL",
          customer_id: this.searchInputs.customer_id,
          customer_name: this.searchInputs.customer_name,
          id_number: this.searchInputs.id_number,
          user_email: this.searchInputs.user_email,
          phone_number: this.searchInputs.phone_number,
          account_status: this.searchInputs.account_status
            ? this.searchInputs.account_status
            : "All",
          kyc_status: this.searchInputs.kyc_status
            ? this.searchInputs.kyc_status
            : "ALL",
          from_date:
            this.searchInputs.date_type === "creation"
              ? this.searchInputs.from_date
              : null,
          to_date:
            this.searchInputs.date_type === "creation"
              ? this.searchInputs.to_date
              : null,
          txn_from_date:
            this.searchInputs.date_type === "transaction"
              ? this.searchInputs.txn_from_date
              : null,
          txn_to_date:
            this.searchInputs.date_type === "transaction"
              ? this.searchInputs.txn_to_date
              : null,
          skip: this.skip,
          limit: this.limit,
        };
        const response = await userService.getRemittenceList(params);
        if (response.status === 200) {
          this.isloadagents = false;
          this.userList = response.data.data;
          // to store the state of the page (handle page when route back )
          this.$store.dispatch("savePreviousPageState", {
            customer_type: this.searchInputs.customer_type
              ? this.searchInputs.customer_type
              : "ALL",
            customer_id: this.searchInputs.customer_id,
            customer_name: this.searchInputs.customer_name,
            id_number: this.searchInputs.id_number,
            user_email: this.searchInputs.user_email,
            phone_number: this.searchInputs.phone_number,
            account_status: this.searchInputs.account_status
              ? this.searchInputs.account_status
              : "All",
            kyc_status: this.searchInputs.kyc_status
              ? this.searchInputs.kyc_status
              : "ALL",
            from_date: this.searchInputs.from_date,
            to_date: this.searchInputs.to_date,
            txn_from_date: this.searchInputs.txn_from_date,
            txn_to_date: this.searchInputs.txn_to_date,
            skip: this.skip,
            limit: this.limit,
          });
        } else {
          this.isloadagents = false;
        }
      } catch (error) {
        this.isloadagents = false;
        console.error(error);
      }
    },

    async totalcuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("totalcuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async todayRegcuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTodayRegCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("todayRegcuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async totalINDcuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalINDCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("totalINDcuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async totalBUScuslist() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalBUSCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("totalBUScuslist", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async totalRejectedcus() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalBUSCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.totalRejectedcus();
        // }
        console.log("totalRejectedcus", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async INDRejectedcus() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getINDRejectCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.INDRejectedcus();
        // }
        console.log("INDRejectedcus", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async BUSRejectedcus() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getBUSRejectCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.BUSRejectedcus();
        // }
        console.log("BUSRejectedcus", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllaproval() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getBUSRejectCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllaproval", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllaprovalIND() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getApprovedINDCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllaprovalIND", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllaprovalBUS() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getApprovedBUSCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        console.log("getAllaprovalBUS", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllhold() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getAllHoldCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getAllhold();
        // }
        console.log("getAllhold", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllholdIND() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getINDHoldCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getAllholdIND();
        // }
        console.log("getAllholdIND", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async getAllholdBUS() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getBUSHoldCustomers();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.userList = responseData.data.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getAllholdBUS();
        // }
        console.log("getAllholdBUS", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },

    nextpage(item) {
      console.log("data ", item);
      this.$router.push({
        name: "List-Overview",

        query: {
          id: item.customer_id,
          login_id: item.login_id,
          customerid: item.customer_id,
          name: item.name,
          user_type: item.user_type,
          pin_no: item.txn_pin,
          risk_status: item.risk_status,
          percentage: item.risk_percentage,
        },
      });
      this.setCustomerRouteData({
        id: item.customer_id,
        customerid: item.customer_id,
        user_type: item.user_type,
        pin_no: item.txn_pin,
        risk_match_list: item.risk_match_list,
        percentage: item.risk_percentage,
      });
      console.log("item", item);
      console.log("customer_id", item.customer_id);
      sessionStorage.setItem("addBeneInd", item.login_id);
      sessionStorage.setItem("Benecustomer_id", item.customer_id);
    },
    async deleteCustomerById() {
      this.isloadagents = true;
      try {
        const responseData = await userService.deleteCustomerById({
          customer_id: this.delete_customer_id,
        });
        if (responseData.data.status_code == 200) {
          this.isloadagents = false;
          this.showAlertSuccess(responseData.data.message);
          await this.getRemitteList();
          this.openDialog = false;
        } else {
          this.isloadagents = false;
          this.showAlertError(responseData.data.message);
        }
      } catch (err) {
        this.isloadagents = false;
        this.showAlertError("Failed: Something went wrong.");
        console.log(err);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
  min-width: 64px !important;
  padding: 0 16px !important;
}
.select-width {
  max-width: 60px;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
